module.exports = __webpack_public_path__ + "54cf98f5/img/verified-icon.f93bbc14.svg";